export const companySortingColumns = [
    'legalName',
    'addressCountryCode',
    'identifierVat',
    'rating',
];
export var CompaniesTypeFilter;
(function (CompaniesTypeFilter) {
    CompaniesTypeFilter["All"] = "all";
    CompaniesTypeFilter["Insured"] = "insured";
    CompaniesTypeFilter["Debtor"] = "debtor";
})(CompaniesTypeFilter || (CompaniesTypeFilter = {}));
